import { FC } from 'react';


import { BodySmall, Box, Modal, ModalHeader } from '@parspec/pixel';

interface SSOErrorPopupProps {
    open: boolean;
    onClose: () => void;
}

const SSOErrorPopup: FC<SSOErrorPopupProps> = ({ open, onClose }) => {
    return (
        <Modal
            open={open}
            header={<ModalHeader title="Account Already Linked" onClose={onClose} />}
        >
            <Box width={400} my={2}>
                <Box>
                    <BodySmall limit={false} color='text.primary'>
                        The selected account is already linked to another Parspec user. Please choose a different account or disconnect it from the current Parspec user it’s associated with.
                    </BodySmall>
                </Box>
            </Box>
        </Modal>
    );
};

export default SSOErrorPopup;
